import * as ct from 'countries-and-timezones';

const FRANCOPHONE_COUNTRIES = [
  'FR', 'BE', 'CH', 'LU', 'MC',
  'SN', 'CI', 'ML', 'BF', 'NE', 'TD', 'GN', 'BJ', 'TG',
  'CM', 'CG', 'CD', 'GA', 'CF', 'DJ', 'KM',
  'MG', 'MU', 'SC',
  'HT',
  'RW', 'BI',
];

export default function detectLanguageFromTimezone() {
  try {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const countries = ct.getCountriesForTimezone(timezone);
    let isFrancophone = false;
    countries.forEach((country) => {
      if (FRANCOPHONE_COUNTRIES.includes(country.id)) {
        isFrancophone = true;
      }
    });
    return isFrancophone ? 'fr' : 'en';
  } catch (e) {
    return 'en';
  }
}
